// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyD0L6VWH3-_FB1W1Nzj-lUoh7mhxdCNuvA",
    authDomain: "cado-95813.firebaseapp.com",
    databaseURL: "https://cado-95813-default-rtdb.firebaseio.com",
    projectId: "cado-95813",
    storageBucket: "cado-95813.appspot.com",
    messagingSenderId: "41804420724",
    appId: "1:41804420724:web:5ef768656dc5061fa3a321"
  };
 // Initialize Firebase
 firebase.initializeApp(firebaseConfig);

 var color;
 var color1 = 0;
 var color2 = 0;
 var color3 = 0;
 var color4 = 0;

 	 firebase.firestore().collection("colors").doc('color1')
	 .onSnapshot((doc)=>{
		 color1=doc.data().count
		 myChart.data.datasets.forEach((dataset) => {
			 dataset.data[0]= color1
			 document.getElementById('vote1').textContent=color1;
		 });
		 myChart.update();
	 });

	 firebase.firestore().collection("colors").doc('color2')
	 .onSnapshot((doc)=>{
		 color2=doc.data().count
		 myChart.data.datasets.forEach((dataset) => {
			 dataset.data[1]= color2
			 document.getElementById('vote2').textContent=color2;
		 });
		 myChart.update();
	 });

	 firebase.firestore().collection("colors").doc('color3')
	 .onSnapshot((doc)=>{
		 color3=doc.data().count
		 myChart.data.datasets.forEach((dataset) => {
			 dataset.data[2]= color3
			 document.getElementById('vote3').textContent=color3;
		 });
		 myChart.update();
	 });

	 firebase.firestore().collection("colors").doc('color4')
	 .onSnapshot((doc)=>{
		 color4=doc.data().count
		 myChart.data.datasets.forEach((dataset) => {
			 dataset.data[3]= color4
			 document.getElementById('vote4').textContent=color4;
		 });
		 myChart.update();
	 });

var ctx = document.getElementById('chart').getContext('2d');
var myChart = new Chart(ctx, {
	 type: 'doughnut',
	 data: {
		 labels: ['色1', '色2', '色3','色4'],
			 datasets: [{
					 label: '# of Votes',
					 data: [color1, color2, color3, color4],
					 backgroundColor: [
							 'rgba(255, 99, 132, 0.2)',
							 'rgba(54, 162, 235, 0.2)',
							 'rgba(255, 206, 86, 0.2)',
							 'rgba(255, 6, 86, 0.2)',

					 ],
					 borderColor: [
							 'rgba(255, 255, 255, 1)',
							 'rgba(255, 255, 255, 1)',
							 'rgba(255, 255, 255, 1)',
							 'rgba(255, 255, 255, 1)',

					 ],
					 borderWidth: 1
			 }],
			 display: false
	 },
	 options: {
			 scales: {
				 	xAxes: [{
						ticks: {
								beginAtZero: false,
								display: false
						},
						gridLines: {
							display: false,
							drawBorder: false
          	}
					}],
					 yAxes: [{
							 ticks: {
									 beginAtZero: false,
									 display: false
							 },
							 gridLines: {
								 display: false,
		             drawBorder: false
		           }
					 }]
			 }
	 }
});

function addData(chart, label, data) {

}

function voteok() {
	$('.votebtn').hide();
	$('.voteokbox').show();
	document.cookie = "votecomplete=on; expires=Tue, 31-Dec-2030 23:59:59;"
	// var now = new Date()
	// var message = 'こんにちは！' + now;
	// $.cookie('votecomplete', message);
	// $('#message').text($.cookie('votecomplete'));
	//
	// $.cookie('votecomplete', 'on', { //cookieにbnrReadという名前でonという値をセット
	// 	 //expires: 30, //cookieの有効日数
	// 	 //path:'/' //有効にするパス
	//  });
}
// $('#message').text($.cookie('votecomplete'));

// $(function(){
// 	cookiename = $.cookie("votecomp");
// 	if(cookiename == "1111"){
// 		$('.votebtn').show();
// 		$('.voteokbox').hide();
// 	}else{
// 		$('.votebtn').hide();
// 		$('.voteokbox').show();
// 	}
// });
//
// if ($.cookie("votecomplete")) {
// 	$('.votebtn').show();
// 	$('.voteokbox').hide();
// }else{
// 	$('.votebtn').hide();
// 	$('.voteokbox').show();
// }

//cookieがあれば見えない
if ($.cookie('votecomplete') != 'on') {
	//$('.votebtnlist').hide();
	//$('.voteokbox').show();
	$('.votebtn').show();
	$('.voteokbox').hide();
}else{
	$('.votebtn').hide();
	$('.voteokbox').show();
}

document.getElementById('btn1').addEventListener('click',()=>{
	 firebase.firestore().collection('colors').doc('color1').set({count:color1+1});
	 voteok();

})

document.getElementById('btn2').addEventListener('click',()=>{
	 firebase.firestore().collection('colors').doc('color2').set({count:color2+1})
	 voteok();
})

document.getElementById('btn3').addEventListener('click',()=>{
	 firebase.firestore().collection('colors').doc('color3').set({count:color3+1})
	 voteok();
})

document.getElementById('btn4').addEventListener('click',()=>{
	 firebase.firestore().collection('colors').doc('color4').set({count:color4+1})
	 voteok();
})

document.getElementById('btn1-1').addEventListener('click',()=>{
	 firebase.firestore().collection('colors').doc('color1').set({count:color1+1});
	 voteok();

})

document.getElementById('btn2-1').addEventListener('click',()=>{
	 firebase.firestore().collection('colors').doc('color2').set({count:color2+1})
	 voteok();
})

document.getElementById('btn3-1').addEventListener('click',()=>{
	 firebase.firestore().collection('colors').doc('color3').set({count:color3+1})
	 voteok();
})

document.getElementById('btn4-1').addEventListener('click',()=>{
	 firebase.firestore().collection('colors').doc('color4').set({count:color4+1})
	 voteok();
})
